import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyBookIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8541 2.94871C15.0345 2.94871 15.9907 3.90508 15.9907 5.0844V12.0655C15.3777 11.5573 14.5905 11.2517 13.7319 11.2517H6.03458C5.9321 11.2517 5.85065 11.1695 5.85065 11.0686V3.1318C5.85065 3.03096 5.9321 2.94871 6.03458 2.94871H13.8541ZM17.2727 14.7925V5.0844C17.2727 3.19677 15.7423 1.66666 13.8541 1.66666H6.03458C5.22569 1.66666 4.5686 2.32121 4.5686 3.1318V4.70309L3.49244 4.6904C2.6768 4.68154 2.00979 5.34042 2.00979 6.15633V16.8673C2.00979 17.6771 2.66603 18.3333 3.47578 18.3333H13.7319C15.6876 18.3333 17.2727 16.7482 17.2727 14.7925ZM4.5686 5.98524V11.0686C4.5686 11.8792 5.22569 12.5337 6.03458 12.5337H13.7319C14.9795 12.5337 15.9907 13.5449 15.9907 14.7925C15.9907 16.0402 14.9795 17.0513 13.7319 17.0513H3.47578C3.37407 17.0513 3.29185 16.969 3.29185 16.8673V6.15633C3.29185 6.05425 3.37535 5.97141 3.47766 5.97237C3.47774 5.97237 3.47757 5.97237 3.47766 5.97237L4.5686 5.98524ZM14.0929 14.8044C14.0929 14.4504 13.8059 14.1634 13.4519 14.1634H5.37116C5.01714 14.1634 4.73013 14.4504 4.73013 14.8044C4.73013 15.1585 5.01714 15.4455 5.37116 15.4455H13.4519C13.8059 15.4455 14.0929 15.1585 14.0929 14.8044Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default IconlyBookIcon;
